import React from "react";
import classes from "./HeaderAction.module.css";
import { FaArrowLeft } from "react-icons/fa6";
import clsx from "clsx"
const HeaderAction = ({
  onClick,
  title,
  icon = <FaArrowLeft color="#fff" />,
  className = "",
  titleClass
}) => {
  return (
    <div className={[classes.wrapper, className].join(" ")}>
      {onClick && (
        <span className={classes.bacKBtn} onClick={onClick}>
          {icon}
        </span>
      )}
      <h2 className={clsx(classes.title, titleClass)}>{title}</h2>
    </div>
  );
};

export default HeaderAction;
